export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
            <rect opacity="0.3" x="0.5" y="0.185547" width="24" height="24" fill="#D8D8D8" fillOpacity="0.01" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.5 16.7855C3.39543 16.7855 2.5 15.8901 2.5 14.7855L2.5 13.0767C2.5 12.8866 2.55423 12.7003 2.65634 12.5399L5.00528 8.84867C5.18884 8.56022 5.50705 8.38555 5.84895 8.38555H6.7C6.81046 8.38555 6.9 8.296 6.9 8.18555V7.18555C6.9 6.08098 7.79543 5.18555 8.9 5.18555H20.9C22.0046 5.18555 22.9 6.08098 22.9 7.18555V14.7855C22.9 15.8901 22.0046 16.7855 20.9 16.7855H4.5Z"
                stroke="url(#paint0_linear_567_3810)"
                strokeLinecap="round"
            />
            <circle cx="6.8998" cy="17.5854" r="1.6" fill="#FDF6E8" stroke="#CD9957" strokeLinecap="round" />
            <circle cx="18.4999" cy="17.5854" r="1.6" fill="#FDF6E8" stroke="#CD9957" strokeLinecap="round" />
            <path d="M6.4999 10.9854L4.8999 13.1854" stroke="#CD9957" strokeLinecap="round" />
            <path d="M9.2998 5.25098L9.2998 13.3859C9.2998 13.9381 9.74752 14.3859 10.2998 14.3859H22.4234" stroke="url(#paint1_linear_567_3810)" />
            <path d="M12.9002 7.98535V11.1854" stroke="url(#paint2_linear_567_3810)" strokeLinecap="round" />
            <path d="M16.0999 7.98535V11.1854" stroke="url(#paint3_linear_567_3810)" strokeLinecap="round" />
            <path d="M19.3001 7.98535V11.1854" stroke="url(#paint4_linear_567_3810)" strokeLinecap="round" />
            <defs>
                <linearGradient id="paint0_linear_567_3810" x1="21.8999" y1="4.9856" x2="3.8999" y2="16.9856" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FBD996" />
                    <stop offset="1" stopColor="#CC9856" />
                </linearGradient>
                <linearGradient id="paint1_linear_567_3810" x1="15.8997" y1="6.48584" x2="8.89966" y2="14.9858" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#ECC482" />
                    <stop offset="1" stopColor="#CF9D5B" />
                </linearGradient>
                <linearGradient id="paint2_linear_567_3810" x1="12.9002" y1="7.98535" x2="12.9002" y2="11.1854" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#DEB270" />
                    <stop offset="1" stopColor="#D3A260" />
                </linearGradient>
                <linearGradient id="paint3_linear_567_3810" x1="16.0999" y1="7.98535" x2="16.0999" y2="11.1854" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#DEB270" />
                    <stop offset="1" stopColor="#D3A260" />
                </linearGradient>
                <linearGradient id="paint4_linear_567_3810" x1="19.3001" y1="7.98535" x2="19.3001" y2="11.1854" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#DEB270" />
                    <stop offset="1" stopColor="#D3A260" />
                </linearGradient>
            </defs>
        </svg>
    );
}
